export const CreditTableColumnId = {
  CREDIT_TYPE: 'creditType',
  DESCRIPTION: 'description',
  SOURCE_TYPE: 'sourceType',
  OTHER_DESCRIPTION: 'otherDescription',
  AMOUNT: 'amount',
  IS_NEWLY_ADDED: 'isNewlyAdded',
};

export const defaultCreditSortOrder = {
  direction: 'desc',
  id: CreditTableColumnId.AMOUNT,
};

export const creditModifiedFieldsToExclude = [
  'applicationCreditId',
  'applicationId',
  'companyId',
  'purchaseCreditSourceType',
  'otherCreditSourceTypeOtherDescription',
  'creditTypeOtherDescription',
];
